import { ApiHelper } from "../../utils/api-helper";
const BAACUrl = `${
    process.env.REACT_APP_API_ENDPOINT
}/api/v2/reports/getBAACTrans`;

class BAACService extends ApiHelper {}

export const BAAC = new BAACService(
    BAACUrl,
);
